import React from "react";
import ResendActivationForm from "../../components/Auth/ResendActivationForm";
import AuthBackgroundSlideshow from "../../components/AuthBackground/Slideshow";

const ResendActivation = () => {
    return (
        <>
            {/* Animated Background Slideshow */}
            <AuthBackgroundSlideshow />
            <ResendActivationForm />
        </>
    );
};

export default ResendActivation;